import NavigationBarControl from '../../../lib/ui/NavigationBarControl'

export default class Export {
  constructor (element, args) {
    this.element = element
    this.args = args

    this.render(element)
  }

  render (element) {
    let fragment = document.createDocumentFragment()

    this.renderNavigation(fragment)

    let div = document.createElement('div')
    div.className = 'viewport'

    let p = document.createElement('p')
    p.innerHTML = 'Er zal een export bestand gemaakt worden van de gegevens die zich op dit moment in uw apparaat bevinden. Let op: uw gegevens worden hierin onversleuteld opgeslagen.'
 
    div.appendChild(p)

    fragment.appendChild(div)

    let button = document.createElement('button')
    button.innerHTML = 'Maak export bestand'
    button.onclick = this.onexport

    fragment.appendChild(button)

    element.appendChild(fragment)
  }

  renderNavigation (element) {
    new NavigationBarControl(element, {
      title: 'Gegevens exporteren',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      }]
    })
  }

  onexport () {    
    let data = {}

    Promise.all([
      window.PRIM.dataAccess.get('people').then((people) => {
        data.people = people
      }),
      window.PRIM.dataAccess.get('organisations').then((organisations) => {
        data.organisations = organisations
      }),
      window.PRIM.dataAccess.get('relationships').then((relationships) => {
        data.relationships = relationships
      }),
      window.PRIM.dataAccess.get('locations').then((locations) => {
        data.locations = locations
      }),
      window.PRIM.dataAccess.get('positions').then((positions) => {
        data.positions = positions
      }),
      window.PRIM.dataAccess.get('educations').then((educations) => {
        data.educations = educations
      }),
      window.PRIM.dataAccess.get('logentries').then((logentries) => {
        data.logentries = logentries
      })
    ]).then(() => {
      let blob = new Blob([JSON.stringify(data)], {type: 'text/json'})
      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, 'export.json')
      } else {
        let url = URL.createObjectURL(blob)
        let tempAnchor = document.createElement('a')
        tempAnchor.href = url
        tempAnchor.download = 'export.json'
        tempAnchor.className = 'invisible'
        document.body.appendChild(tempAnchor)
        tempAnchor.click()
        document.body.removeChild(tempAnchor)
        URL.revokeObjectURL(url)
      }
    }, () => {      
      alert('Er is iets fout gegaan tijdens het maken van het export bestand. Probeer het opnieuw.')
    })
  }
}



// WEBPACK FOOTER //
// ./js/modules/export/action/Export.js